import safetyMeetingRequestStatusTemplate from "./safety_meeting_request_status_template.html";
import en from "./en.translation.json";
import es from "./es.translation.json";
import _ from "lodash";
import { SID_LOOKUP } from "../../../../app.constants";
import { CANCELLED, COMPLETE, PENDING } from "../../safety.constants";

class SafetyMeetingRequestStatusController {
    constructor() {
        this.CANCELLED = CANCELLED;
        this.COMPLETE = COMPLETE;
        this.PENDING = PENDING;
    }

    $onInit() {
        let ctrl = this;
        ctrl.topic = _.find(ctrl.topics, [SID_LOOKUP, ctrl.request.topic]);
    }
}
export default {
    bindings: { request: "<", topics: "<" },
    controller: SafetyMeetingRequestStatusController,
    template: safetyMeetingRequestStatusTemplate,
    name: "safetyMeetingRequestStatus",
    translations: { en, es },
};
